import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

import LandingPage from './pages/LandingPage';
import MonitoringPage from './pages/MonitoringPage';
import DonorListPage from './pages/DonorListPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminAnimals from './pages/AdminAnimals';
import AdminDonors from './pages/AdminDonors';
import AdminProcess from './pages/AdminProcess';
import AdminDistribution from './pages/AdminDistribution';
import AdminCouriers from './pages/AdminCouriers';
import AdminSettings from './pages/AdminSettings';
import CourierLogin from './pages/CourierLogin';
import CourierDashboard from './pages/CourierDashboard';
import CourierTracking from './pages/CourierTracking';
import Navbar from './components/Navbar';

function ProtectedRoute({ children, requiredRole }) {
  const { user, role } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && role !== requiredRole) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/monitoring" element={<MonitoringPage />} />
        <Route path="/pengkurban" element={<DonorListPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/courier-login" element={<CourierLogin />} />
        <Route path="/tracking/:courierId" element={<CourierTracking />} />

        {/* Admin routes */}
        <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/hewan" element={<ProtectedRoute requiredRole="admin"><AdminAnimals /></ProtectedRoute>} />
        <Route path="/admin/pengkurban" element={<ProtectedRoute requiredRole="admin"><AdminDonors /></ProtectedRoute>} />
        <Route path="/admin/proses" element={<ProtectedRoute requiredRole="admin"><AdminProcess /></ProtectedRoute>} />
        <Route path="/admin/distribusi" element={<ProtectedRoute requiredRole="admin"><AdminDistribution /></ProtectedRoute>} />
        <Route path="/admin/kurir" element={<ProtectedRoute requiredRole="admin"><AdminCouriers /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute requiredRole="admin"><AdminSettings /></ProtectedRoute>} />

        {/* Courier routes */}
        <Route path="/kurir" element={<ProtectedRoute requiredRole="courier"><CourierDashboard /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    </AuthProvider>
  );
}
